import React from "react";
import PageHero from "@/components/PageHero";

/**
 * SoulHero — kept as a thin alias over PageHero so every Soul sub-page
 * shares the exact same minimal hero as the rest of the app.
 * (Retained as its own component only to avoid touching every import.)
 */
export default function SoulHero(props) {
  return <PageHero {...props} testid={props.testid || "soul-hero"} />;
}
